import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import LocalizationHelper from './localizationHelper';

export default function useTranslation() {
  const { language } = useContext(UserContext);
  const translate = new LocalizationHelper(language);
  return translate.getText;
}
